
import Images from '../../state/stores/Image/images';
import PressableScale from '../PressableScale/PressableScale';
import React from 'react';
import { Animated, Image, ImageBackground, StyleSheet, View } from 'react-native';
import { CIRCLE_MARGIN, CIRCLE_SIZE } from '../../config/designSystem/Colors';
import { Contacted } from '../Library/Contacted';
import { FlatListItemProps } from '../../types/navigation';
import { ParagraphMBold, ParagraphSRegular } from '../../config/designSystem/typography';
import { REGULAR_HORIZONTAL_MARGIN_FN, WIDTH_PSYCHO_CARD, isWeb } from '../../config/designSystem/Layout';
import { RibbonPsychoCard } from '../../assets/images/ribbonPsychoCard';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';
import { useStores } from '../../hooks/useStores';




export const AssistanceItemNew = ({ item }: FlatListItemProps) => {
  const { width } = useAvailableDimensions();

  const rootStore = useStores();
  const labels = rootStore?.language.translate.MOBILE.ASSISTANCE;

  const styles = StyleSheet.create({
    itemContainer: {
      marginTop: 5,
      marginHorizontal: REGULAR_HORIZONTAL_MARGIN_FN(width*2),
      borderRadius: 12,
      shadowColor: '#000',
      position:'relative',
      elevation: 5,
      alignSelf: 'stretch',
    },
    center: { alignItems: 'center' },
    marginTopSmall: { marginTop: 2 },
    innerImage: {
      width: item.image.size ? item.image.size : CIRCLE_SIZE,
      height: item.image.size ? item.image.size : CIRCLE_SIZE,
      margin: CIRCLE_MARGIN,
      borderRadius: item.image.size ? item.image.size : CIRCLE_SIZE,
    },
    starImage: {
      width: item.image.size ? item.image.size / 3 : CIRCLE_SIZE / 3,
      height: item.image.size ? item.image.size / 3 : CIRCLE_SIZE / 3,
      margin: CIRCLE_MARGIN / 4,
      borderRadius: item.image.size ? item.image.size / 3 : CIRCLE_SIZE / 3,
    },

    ribbon:{
      position:'absolute',
      top:-6,
      right:-8,
      zIndex:10
    }
  });

  const scaleAnimation = React.useRef(new Animated.Value(1)).current;
  const WIDTH_WEB = Math.max(300, width*0.8);
  const HEIGHT = 100;
  const factorResize = isWeb?5:width/50;
  return (
    <PressableScale scaleAnimation={scaleAnimation} onPress={item.onPress} >
      <Animated.View
        style={[
          styles.itemContainer,
          {
            transform: [{ scale: scaleAnimation }],
            backgroundColor:item.backgroundColor,
            width:isWeb? WIDTH_WEB:WIDTH_PSYCHO_CARD(width),
            height: HEIGHT,
          },
          !isWeb && {paddingHorizontal:10},
          isWeb && {marginTop:8, marginHorizontal:0},
        ]}
      >
        {item.secondImage === 'user' && (
          !isWeb? (<View style={[styles.ribbon]}>
            <RibbonPsychoCard color={'#4F9EB5'} title={labels?.CONTACTED_THERAPIST} />
          </View>):
            (<Contacted label={labels?.CONTACTED_THERAPIST?labels?.CONTACTED_THERAPIST:''} />))
        }


        <View style={[{flexDirection:'row', flex:1, paddingVertical:5, flexWrap:'wrap'}, !isWeb && { zIndex:10}]}>
          <View>
            <Image
              source={item.image.fromStore ? Images[item.image.storeName][item.image.imageName] : { uri: item.image.uri }}
              style={[
                styles.innerImage,
                {
                  backgroundColor: item.color,
                },
              ]}
            />
          </View>
          <View
            style={[{
              rowGap:5,
              marginLeft: 10,
              flex:1,
            }, !item.isNotFound && {marginTop:10}]}>

            <View style={{paddingRight:5}}>
              <ParagraphMBold >
                {item.title}
              </ParagraphMBold>
            </View>
            <View style={{paddingRight:5}}>
              <ParagraphSRegular>
                {item.description}
              </ParagraphSRegular>
            </View>
          </View>

        </View>
        <View style={{position:'absolute', right:0, bottom:0,  alignItems:'flex-end', justifyContent:'flex-end', zIndex:-10, backgroundColor:'transparent'}}>
          <ImageBackground
            source={Images.assistance[item.background]}
            style={[{ paddingBottom:10,width:680/factorResize, height: 512/factorResize, backgroundColor:'transparent', opacity: 0.5}]}
            width={680/factorResize}
            height={512/factorResize}
            resizeMode='contain'
          />
        </View>
      </Animated.View>
    </PressableScale>
  );
};
